import React from "react";
import Typed from "react-typed";
import { Link } from "gatsby";
import Layout from "../components/layout";
import SEO from "../components/seo";
import SocialConnect from "../components/SocialConnect";

var IndexPage = function IndexPage() {
  return React.createElement(Layout, null, React.createElement(SEO, {
    title: "Home",
    keywords: ["Curtiba", "front end developer", "react developer", "javascript developer", "ARANHA AGENCY", "developer", "london", "Rio de Janeiro", "Brasil", "Advertising", "Integrated Advertising", "Networking", "Advertising Agency", "Agencia de Publiade", "Publicidade no Whatsapp", "New York Advertising Agency", "Curitiba Advertising Agency", "Rio Advertising Agency", "Ag\xEAncia de Publicidade", "Rio Ag\xEAncia", "Goiania Agencia de Publicidade"]
  }), React.createElement("section", {
    id: "home"
  }, React.createElement("div", {
    className: "container",
    style: {
      position: "relative",
      zIndex: 1
    }
  }, React.createElement("h2", null, React.createElement(Typed, {
    loop: true,
    typeSpeed: 80,
    backSpeed: 20,
    strings: ["We <span class='accent'>ARANHA</span> Agency", "We <span class='accent'>CREATIVE AGENCY</span>.", "We are <span class='accent'>Publicidade</span>.", "We are <span class='accent'>Propaganda</span> mind."],
    smartBackspace: true,
    backDelay: 1000,
    loopCount: 0,
    showCursor: true,
    cursorChar: "|",
    className: "typed"
  })), React.createElement("p", null, "Somos o futuro da propaganda,", " ", React.createElement(Link, {
    to: "/contact/"
  }, React.createElement("strong", null, "Vamos tomar um caf\xE9")), " "), React.createElement(SocialConnect, null))));
};

export default IndexPage;